import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { SeoPageState, SeoState, StateWithSeo } from '../seo-state';
import { getFeatureState } from './feature.selector';

export const getPageState: MemoizedSelector<StateWithSeo, StateUtils.LoaderState<SeoPageState | null>> = createSelector(
  getFeatureState,
  (state: SeoState) => state.page,
);

export const getPageValue: MemoizedSelector<StateWithSeo, SeoPageState | null> = createSelector(
  getPageState,
  (state: StateUtils.LoaderState<SeoPageState | null>) => StateUtils.loaderValueSelector(state),
);

export const getPageLoading: MemoizedSelector<StateWithSeo, boolean> = createSelector(
  getPageState,
  (state: StateUtils.LoaderState<SeoPageState | null>) => StateUtils.loaderLoadingSelector(state),
);

export const getPageError: MemoizedSelector<StateWithSeo, boolean> = createSelector(
  getPageState,
  (state: StateUtils.LoaderState<SeoPageState>) => StateUtils.loaderErrorSelector(state),
);

export const getPageSuccess: MemoizedSelector<StateWithSeo, boolean> = createSelector(
  getPageState,
  (state: StateUtils.LoaderState<SeoPageState>) => StateUtils.loaderSuccessSelector(state),
);
